<template>
    <div class="templete">
        <div class="search_box search_box_f no_print clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="采购单号"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectList('breed')">
                <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectList('supplier')">
                <el-option v-for="list in selectMap.supplier" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.status" collapse-tags placeholder="采购单状态" filterable>
                <el-option v-for="list in purchaseStatusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.purchase_type" multiple collapse-tags placeholder="采购类型" filterable>
                <el-option v-for="list in purchaseTypeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.remark" placeholder="备注"></el-input>
            <div class="searchBtnList clearfix">
                <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible;scene='cloud.purchase.list';isGlobal=false;filter=copy_filter;"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList no_print clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="dialogCloud=!dialogCloud;cloudId='';cloudIsEdit = true;">新建采购单</el-button>
            <el-button class="funcPublicBtn" @click="examine">提交审核</el-button>
            <el-button class="funcPublicBtn" @click="examinePass">审核通过</el-button>
            <el-button class="funcPublicBtn" @click="batchDel">批量删除</el-button>
            <!-- <el-button class="funcPublicBtn">捆包明细</el-button> -->
        </div>
        <div class="tableBox no_print">
            <tabletem :isSetCol="true" :scene="scene" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @isCancel="recall" @getTableDelete="getTableDelete" @getTableSee="getTableSee" @getTableEdit="getTableEdit" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal no_print">
            <div class="totalName">合计：</div>
            <div class="totalNumber">订单数量:{{totalObj.total_sum}}</div>
            <div class="totalNumber">入库数量:{{totalObj.stock_sum}}</div>
            <div class="totalNumber">在途数量{{totalObj.ship_sum}}</div>
            <div class="totalNumber">外币总金额:{{totalObj.foreign_currency_total}}</div>
            <div class="totalNumber">实付总额:{{totalObj.rmb_cost_amount}}</div>
            <div class="totalNumber">税金总额:{{totalObj.tax_total}}</div>
            <div class="totalNumber">包干费总额{{totalObj.local_charge_total}}</div>
        </div>
        <div class="pageBox no_print">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC threeLabel no_print eldialogWidth" :modal="false" :title="'采购单('+form_params.contract_no+')'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="采购人：" prop="creator_name">
                            <el-input v-model="form_params.creator_name" readonly></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                         <el-form-item  label="采购日期：" prop="contract_time">
                            <el-date-picker v-model="form_params.contract_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="供应商：" prop="supplier">
                            <el-input v-model="form_params.supplier" readonly></el-input>
                        </el-form-item>
                    </div>
                    <!-- <div class="elFormBox">
                        <el-form-item  label="件数：" prop="order_count">
                            <el-input v-model="form_params.order_count" readonly></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item  label="方数：" prop="contract_no">
                            <el-input v-model="form_params.cube" readonly></el-input>
                        </el-form-item>
                    </div> -->
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" ref="outBoundDetailTable" border stripe highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作" width="67" show-overflow-tooltip v-if="formIsEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDel(scope.row.id,scope.row.inventory_cloud_id)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip  v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="品牌" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.brand }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="等级" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.length }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column label="件数" width="80" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        {{ scope.row.order_count }}
                                    </template>
                                </el-table-column> -->
                                <el-table-column label="片数" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',width_total,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.width_total }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="立方" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="单价" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',cube_price,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="金额" width="80" show-overflow-tooltip  v-if="billColumn.indexOf(',total_amount,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.total_amount }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" :readonly="true" v-model="form_params.remark" cols="5"></textarea>
                    </div>
                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="print">打印</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" style="width:120px;" v-if="formIsEdit" @click="savePur">保存并提交审核</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <el-dialog v-dialog-drag :visible.sync="seeRemarksFlag" class="eldialog no_print eldialogA" width="500px" :modal="false" title="其它备注" custom-class="full_dialog">
            <div class="remarksBox">
                <div class="remarksText" v-show="seeRemarks.length>0" v-for="(item,index) in seeRemarks" :key="index">{{(index+1)+'、'+item.remark}}</div>
                <div class="remarksText" v-show="seeRemarks.length<=0" style="text-align:center">无</div>
            </div>
        </el-dialog>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter"  :scene="scene" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!--选择库存START-->
        <el-dialog  v-dialog-drag :visible.sync="dialogVisibleStock" class="eldialog no_print eldialogStock" width="1250px" :modal="false" title="选择货物" custom-class="full_dialog">
            <cloud-select-product ref="selectstock" @cancel="dialogVisibleStock=!dialogVisibleStock" @selectData="selectData" @selectAndOut="selectAndOut"></cloud-select-product>
        </el-dialog>
        <!--选择库存END-->
        <!-- 创建云链订单 START -->
        <cloudorder :dialogCloud="dialogCloud" :id="cloudId" :cloudIsEdit="cloudIsEdit" @close="()=>{this.dialogCloud = false;this.cloudId = '';}" @success="()=>{this.getList()}"></cloudorder>
        <!-- 创建云链订单 END -->
    </div>
</template>
<style scoped lang="scss">
    .elFormBoxBtnList .funcPublicBtnChecked{margin-left:50px;}
    .labelTip{display: none;position: absolute;bottom:20px;left:-150px;z-index:1;width:400px;text-align: left;background-color: #868686;border-radius: 4px;padding:10px;box-sizing: border-box;}
    .laCbelTipC{color:white;font-size: 12px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .remarksText{text-align: left;padding:5px 10px;}
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
</style>
<script>
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    import cloudorder from '../../components/purchase/createCloudOrder.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                cloudId:"",
                cloudIsEdit:false,
                dialogCloud:false,
                dialogVisibleStock:false,
                isGlobal:false,
                scene:"cloud.purchase.list",
                copy_filter:"",
                printDetail:{
                    fields:"",
                    statistic:{}
                },
                printTotal:[],
                companyName:localStorage.dw_erp_company_name,
                
                module:localStorage.dw_erp_power_code,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                isShowMore:false,
                start_time:"",
                end_time:"",
                start_arrival_time:"",
                end_arrival_time:"",
                start_actual_time:"",
                end_actual_time:"",
                payment_time:"",
                contractType:2,//2新增 3修改
                feeList:[],
                contractForm:{
                    id:"",
                    contract_no:"",
                    contract_time:"",
                    container_no:"",
                    supplier_id:"",
                    expected_arrival_time:"",
                    expected_shipping_time:"",
                    port_id:"",
                    breed_id:[],
                    brand_id:[],
                    thickness:"",
                    length:"",
                    foreign_currency_id:"",
                    foreign_currency_amount:"",
                    cube:"",
                    original_cube:"",
                    rmb_amount:"",
                    rmb_cost_amount:"",
                    payer:"",
                    remark:"",
                    category:"",
                    actual_arrival_time:"",
                    tax:"",
                    payment_time:"",
                    receipt_invoice:"",
                    invoice_no:"",
                    bill_lading_no:"",
                    status:"",
                    customs_broker:"",
                    grade_id:[],
                    place_origin:"",
                    board_unit:"m³",
                    total_board_feet:"",
                    foreign_currency_unit:"",
                    foreign_currency_price:"",
                    exchange_rate:"",
                    purchase_amount:0,
                    remarks:[]
                },
                params:{
                    start_time:"",
                    end_time:"",
                    brand_id:"",
                    breed_id:"",
                    remark:"",
                    purchase_type:"",
                    status:"",
                    page:1,
                    per_page:50
                },
                last_page:1,
                total:0,
                selectRow:[],
                categoryList:[],
                selectMap:{
                    supplier:[],
                    breed:[],
                    brand:[],
                    creater:[],
                    grade:[],
                    port:[],
                    purchaseCost:[],
                    currency:[]
                },
                list:[],
                tableCol:[
                    {colName:"采购单状态",colKey:"status_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购日期",colKey:"contract_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购单号",colKey:"contract_no",colWidth:180,isSetWidth:true,isCanClick:true,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"件数",colKey:"order_count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购方数",colKey:"cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库方数",colKey:"storage_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购金额",colKey:"rmb_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商",colKey:"supplier",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购人",colKey:"purchaser_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"审核人",colKey:"auditor_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购类型",colKey:"purchase_type_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                totalObj:{},
                filterDialogVisible:false,
                filter:"",
                fields:"",
                seeRemarks:[],
                seeRemarksFlag:false,

                billColumn:"",
                listDetail:[],
                dialogVisible:false,
                form_params:{
                    id:"",
                    auditor_name: "",
                    contract_no: "",
                    contract_time: "",
                    creator_name: "",
                    cube: "",
                    details: [],
                    order_count: "",
                    remarks: [],
                    supplier: ""
                },
                formIsEdit:false,
                purchaseTypeList:[],
                purchaseStatusList:[]
            }
        },
        created(){
            // this.getSelectList("supplier")
            // this.getSelectList("breed")
            // this.getSelectList("brand")
            // this.getSelectList("creater")
            // this.getSelectList("grade")
            // this.getSelectList("port")
            // this.getSelectList("purchaseCost")
            // this.getSelectList("currency")
            this.getPurchaseTypeList()
            this.getPurchaseStatusList()
            this.postFunc("/erp/purchase.category",{},res=>{
                this.categoryList=res.data.data;
                if(res.data.data.length==1){
                    this.contractForm.category=res.data.data[0].id
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
        },
        methods:{
            examine(){
                if(this.selectRow.length < 1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    let flag = true;
                    this.selectRow.forEach(item=>{
                        if(item.status == 1){
                            flag = false;
                        }else{
                            arr.push(item.id)
                        }
                    })
                    if(flag){
                        this.$confirm('是否提交审核?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.postFuncLoading("/erp/cloud.purchase.submit",{ids:arr},()=>{
                                this.tip("提交成功","success")
                                this.getList()
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    }else{
                        this.tip("选中数据有不可提交审核项","warning")
                    }
                }
            },
            examinePass(){
                if(this.selectRow.length < 1){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let arr = new Array();
                    let flag = true;
                    this.selectRow.forEach(item=>{
                        if(item.status == 1){
                            flag = false;
                        }else{
                            arr.push(item.id)
                        }
                    })
                    if(flag){
                        this.$confirm('是否审核通过?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.postFuncLoading("/erp/cloud.purchase.audit",{ids:arr},()=>{
                                this.tip("审核通过","success")
                                this.getList()
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    }else{
                        this.tip("选中数据有不可审核通过项","warning")
                    }
                }
            },
            getPurchaseTypeList(){
                this.postFunc("/erp/cloud.purchase.type",{},res=>{
                    this.purchaseTypeList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPurchaseStatusList(){
                this.postFunc("/erp/cloud.purchase.status",{},res=>{
                    this.purchaseStatusList = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            recall(id){
                this.$confirm('是否确定撤回?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/cloud.purchase.revoke",{id:id},()=>{
                        this.tip("撤回成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            savePur(){
                this.$confirm('是否确定提交?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form_params.details = this.listDetail;
                    this.postFunc("/erp/cloud.purchase.update",this.form_params,()=>{
                        this.tip("提交成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            listDel(id,idT){
                let num = 0;
                let cube = 0;
                let idSign = id ? id:idT;
                let data = JSON.parse(JSON.stringify(this.listDetail));
                this.listDetail.forEach((item,index)=>{
                    if((id ? item.id:item.inventory_cloud_id) == idSign){
                        data.splice(index,1)
                    }else{
                        num += Number(item.order_count);
                        cube += this.keepLimit(Number(item.cube));
                    }
                })
                this.listDetail = data;
                this.form_params.order_count = num;
                this.form_params.cube = cube;
            },
            batchDel(){
                if(this.selectRow.length<=0){
                    this.tip("请先选择数据","warning")
                    return;
                }else{
                    let flag = true;
                    let id = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(this.selectRow[i].isDelete!=1){
                            this.tip("有不可删除数据","warning")
                            flag = false;
                            break;
                        }else{
                            id.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.$confirm('是否确定删除?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.postFunc("/erp/cloud.purchase.delete",{ids:id},()=>{
                                this.tip("删除成功","success")
                                this.getList();
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    }
                }
            },
            getSelectList(target){
                let obj = new Object();
                if(target=="purchaseCost"){
                    obj.types = 2;
                }
                this.$getSelectList(target,obj).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            excelExport(){
                this.$exportExecl("/erp/cloud.purchase.excel","云链采购合同",this.params)
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time)
                this.params.end_time=this.formatTimeZero(this.end_time)
                this.params.payment_time=this.formatTimeZero(this.payment_time)
                this.params.start_arrival_time=this.formatTimeZero(this.start_arrival_time)
                this.params.end_arrival_time=this.formatTimeZero(this.end_arrival_time)
                this.params.start_actual_time=this.formatTimeZero(this.start_actual_time)
                this.params.end_actual_time=this.formatTimeZero(this.end_actual_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/cloud.purchase.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    // this.params.page=parseInt(res.data.data.list.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.totalObj=res.data.data.total;
                    this.list=res.data.data.list.data;
                    this.list.forEach((item,index)=>{
                        if(item.contract_time!=0){
                            this.list[index].contract_time = this.formatTime(item.contract_time+"000")
                        }else{
                            this.list[index].contract_time = ""
                        }
                    })
                    this.filter = res.data.data.column;
                    this.copy_filter = JSON.parse(JSON.stringify(res.data.data.column))
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //选择库存信息
            selectData(row){
                let rowData = JSON.parse(JSON.stringify(row))
                this.listDetailSet(rowData)
            },
            selectAndOut(row){
                let rowData = JSON.parse(JSON.stringify(row))
                this.listDetailSet(rowData)
                this.dialogVisibleStock = !this.dialogVisibleStock;
            },
            listDetailSet(row){
                if(row.length<1){
                    return;
                }
                let rows=JSON.parse(JSON.stringify(row));
                let arr = new Array();
                rows.forEach(item=>{
                    let flag = true;
                    this.listDetail.forEach(li=>{
                        if(li.inventory_cloud_id){
                            if(li.inventory_cloud_id == item.id){
                                flag = false;
                            }
                        }else{
                            if(li.id == item.id){
                                flag = false;
                            }
                        }
                    })
                    if(flag){
                        item.inventory_cloud_id = item.id;
                        item.thickness = item.sales_thickness;
                        item.length = item.sales_length;
                        item.width_total = item.sales_width_total;
                        item.cube = item.sales_cube;
                        item.cube_price = item.sales_price;
                        item.total_amount = this.keepPrice(item.sales_cube * item.sales_price)
                        delete item.id;
                        arr.push(item)
                    }
                })
                this.listDetail = this.listDetail.concat(arr);
            },

            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                if(obj.name=="contract_no"){
                    // this.postFuncLoading("/erp/cloud.purchase.view",{id:obj.id},res=>{
                    //     this.form_params = res.data.data.list;
                    //     this.form_params.contract_time = res.data.data.list.contract_time * 1000;
                    //     this.listDetail = res.data.data.list.details;
                    //     this.scene = 'cloud.purchase.view';
                    //     this.isGlobal = true;
                    //     this.getBillColumn()
                    //     this.dialogVisible = true;
                    //     this.formIsEdit = false;
                    // },error=>{
                    //     this.tip(error.data.message,"warning")
                    // })
                    this.cloudId = obj.id;
                    this.dialogCloud = true;
                    this.cloudIsEdit = false;
                }else if(obj.name=="remark"){
                    this.list.forEach(item=>{
                        if(obj.id==item.id){
                            this.seeRemarks = item.remarks;
                            this.seeRemarksFlag = !this.seeRemarksFlag;
                        }
                    })
                }
            },
            //打印
            print(){
                let url = "/saleOrderPrint?id=" + this.form_params.id + "&category=" + 5;
                window.open(url);
            },
            getTableDelete(id){
                this.$confirm('是否确定删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids = new Array();
                    ids.push(id)
                    this.postFunc("/erp/cloud.purchase.delete",{ids:ids},()=>{
                        this.tip("删除成功","success")
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableSee(id){
                this.pl(id)
            },
            getBillColumn(){
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getTableEdit(id){
                // this.postFuncLoading("/erp/cloud.purchase.view",{id:id},res=>{
                //     this.form_params = res.data.data.list;
                //     this.form_params.contract_time = res.data.data.list.contract_time * 1000;
                //     this.listDetail = res.data.data.list.details;
                //     this.scene = 'cloud.purchase.view';
                //     this.isGlobal = true;
                //     this.getBillColumn()
                //     this.formIsEdit = true;
                //     this.dialogVisible = true;
                // },error=>{
                //     this.tip(error.data.message,"warning")
                // })
                this.cloudId = id;
                this.dialogCloud = true;
                this.cloudIsEdit = true;
            },
            getRow(row){
                this.selectRow=row;
            }
        },
        components:{
            tabletem,
            pagination,
            cloudorder
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.form_params = {id:"",auditor_name: "",contract_no: "",contract_time: "",creator_name: "",cube: "",details: [],order_count: "",remarks: [],supplier: ""};
                    this.listDetail = [];
                }
            },
            "dialogVisibleStock":function(val){
                if(val){
                    this.$nextTick(()=>{
                        this.$refs['selectstock'].resetSelect();
                    })
                }
            },
        }
    }
</script>
